<section class="col-lg-4 col-md-8 col-sm-9 pt-1 p-0 content__form__input">
  <label class="label__form">{{ labelInput }}<span *ngIf="isRequired" class="label__form__required">*</span></label>
  <input #fileInput [attr.id]="tipoDocumento" (change)="onFileSelected($event)"
    accept="image/*,capture=camera,application/pdf" class="inputfile" type="file" onclick="this.value=null"
    [attr.multiple]="(isMultiple == true || isMultiple == null) ? true : null" />
  <label (keyup.enter)="tipoDocumento.click()" [attr.for]="tipoDocumento" tabindex="0"
    class="form-control input-form form-label">
    <span class="file-box d-inline-block text-truncate">Selecione o(s) Arquivo(s)</span>
    <fa-icon [icon]="icone" size="1x" class="card__header__icon"></fa-icon>
  </label>
  <small class="form-text text-muted danger" *ngIf="isRequired && errorRequired" [@fadeIn]>
    Por favor, selecione um arquivo!
  </small>
</section>